import { render, staticRenderFns } from "./textarea-col.vue?vue&type=template&id=cb46f404&"
import script from "./textarea-col.vue?vue&type=script&lang=js&"
export * from "./textarea-col.vue?vue&type=script&lang=js&"
import style0 from "./textarea-col.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "textarea-col.vue"
export default component.exports